import React, { useEffect, useState } from "react";
import {
	Avatar,
	Box,
	Button,
	Card,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	Grid,
	IconButton,
	Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import Axios from "axios";
import constants from "../Constants";
import check from "../images/check.png";
import FormatHelper from "../helper/FormatHelper";
import { useDispatch } from "react-redux";
import { setUpdateStudents } from "../store/actions";

function AddStudentToClass({
	allStudents,
	studentModal,
	setStudentModal,
	classData,
	fetchClassList,
	setClassStudents,
	setMsg,
}) {
	const dispatch = useDispatch();
	const [addLoading, setAddLoading] = useState(false);
	const [studentsList, setStudentsList] = useState([]);
	const [selectedStudents, setSelectedStudents] = useState(false);

	const addStudentHandler = async () => {
		try {
			setAddLoading(true);
			setMsg(null);
			const body = {
				classes: studentsList.filter(i => i.checked).map(s => ({ userId: s.id })),
			};
			const response = await Axios.post(
				constants.baseUrl + "/class/add/member/" + classData?.classId,
				body,
				{
					headers: {
						authorization: "Bearer " + localStorage.getItem("schoolToken"),
					},
				}
			);
			if (response.data.status === 201) {
				fetchClassList();
				setClassStudents(prev => [
					...prev,
					...response.data.result.newMembers.filter(
						newMember =>
							!prev.some(existingStudent => existingStudent.id === newMember.id)
					),
				]);
				dispatch(setUpdateStudents(response.data.result.newMembers));
				setStudentModal(false);
				setMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "دانش آموزان جدید اضافه شدند",
				});
			} else {
				setMsg({
					header: "تلاش ناموفق",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setMsg({
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		} finally {
			setAddLoading(false);
		}
	};

	const toggleStudentChecked = index => {
		setStudentsList(prev =>
			prev.map((student, i) =>
				i === index ? { ...student, checked: !student.checked } : student
			)
		);
	};

	useEffect(() => {
		const copy = [...allStudents];
		setStudentsList(copy.map(i => ({ ...i, checked: false })));
	}, [allStudents]);

	return (
		<Dialog open={studentModal} fullWidth maxWidth="lg">
			<Box
				px={2}
				py={1}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"space-between"}>
				<Typography fontSize={16} fontWeight={700}>
					اضافه کردن دانش آموز به کلاس{" "}
					{FormatHelper.toPersianString(`${classData?.className}`)}
				</Typography>
				<Box className="d-flex" gap={2}>
					<Typography fontSize={16} fontWeight={700}>
						تعداد دانش آموزان انتخاب شده :{" "}
						{FormatHelper.toPersianString(
							`${studentsList?.filter(i => i.checked)?.length}`
						)}
					</Typography>
					<Button
						variant="outlined"
						color="secondary"
						onClick={() => setSelectedStudents(!selectedStudents)}>
						{selectedStudents ? "لیست همه دانش آموزان" : "لیست دانش آموزان انتخابی"}
					</Button>
				</Box>
				<IconButton
					onClick={() => {
						setStudentModal(false);
					}}>
					<CloseIcon />
				</IconButton>
			</Box>
			<DialogContent>
				<Grid container mt={1} spacing={2}>
					{studentsList
						?.filter(i => (selectedStudents ? i.checked : i))
						?.map((student, index) => (
							<Grid key={index} item xs={12} md={4} sx={{ minHeight: "100px" }}>
								<Card
									onClick={() => !student.class && toggleStudentChecked(index)}
									elevation={3}
									sx={{
										p: 1,
										cursor: "pointer",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										minHeight: "90px",
										gap: 1,
										backgroundColor: student.class && "#eee",
									}}>
									<Box sx={{ position: "relative", display: "flex" }}>
										<Avatar
											src={constants.baseUrl + "/user/avatar/" + student.avatar}
											alt={`student${student.firstName}avatar`}
											sx={{ width: 70, height: 70 }}
										/>
										<img
											src={check}
											alt="checkImage"
											style={{
												display: student.checked ? "flex" : "none",
												height: "20px",
												width: "20px",
												position: "absolute",
												right: 0,
												bottom: 0,
											}}
										/>
									</Box>

									<Box
										sx={{
											display: "flex",
											justifyContent: "space-around",
											flexDirection: "column",
										}}
										width={"100%"}>
										<Typography fontSize={14}>
											نام : {student.firstName + " " + student.lastName}
										</Typography>
										<Typography fontSize={14}>پایه : {student.grade?.name}</Typography>
										<Typography fontSize={14}>
											موبایل : {FormatHelper.toPersianString(`${student.mobile}`)}
										</Typography>
										{student.class && (
											<Typography fontSize={14} color={"secondary"}>
												کلاس : {student.class?.className}
											</Typography>
										)}
									</Box>

									<Checkbox
										checked={student.checked}
										disabled={student.class}
										onChange={() => toggleStudentChecked(index)}
										onClick={e => e.stopPropagation()}
									/>
								</Card>
							</Grid>
						))}
				</Grid>
			</DialogContent>

			<DialogActions>
				<LoadingButton
					variant="contained"
					color="secondary"
					onClick={addStudentHandler}
					sx={{ fontSize: "16px", color: "white", my: 1 }}
					loading={addLoading}>
					اضافه کردن
				</LoadingButton>
				<Button
					variant="contained"
					sx={{ fontSize: "16px", mr: 2, my: 1 }}
					onClick={() => {
						setStudentModal(false);
						setMsg(null);
					}}>
					انصراف
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default AddStudentToClass;
